import { create } from 'zustand';

/**
 * Double écran « Régie » — pont interne entre ScreenApp (qui sait si la page est
 * l'écran public) et le bridge de l'iframe (useWebViewPlugin, qui le dit au jeu
 * via le message `set-presentation` pour qu'il cache ses propres commandes).
 * État idempotent, comme useRemoteGameParams : re-poussé à chaque jeu prêt.
 */
type PresentationStore = {
    isPublic: boolean;
    setPublic: (isPublic: boolean) => void;
};

export const usePresentation = create<PresentationStore>((setState) => ({
    isPublic: false,
    setPublic: (isPublic) => setState({ isPublic }),
}));
